import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import GeneralCompanyInformation from './general_company_information/GeneralCompanyInformation';
import ProjectOverview from './project_overview/ProjectOverview';
import ProjectDetailTabs from './project_detail/ProjectDetailTabs';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import elsterProjectsService from '../../services/elster/elster_projects.service';
const CompanyCosts = _ref => {
  let {
    elster,
    setElster,
    handleToaster,
    fetchElster
  } = _ref;
  const [loading, setLoading] = useState(false);
  const accountType = useSelector(state => state.auth.user.account_type);
  const [key, setKey] = useState('project_overview');
  const [projectReports, setProjectReports, fetchAllProjetcs] = elsterProjectsService.useFetchAll({
    elsterId: elster.id,
    accountType,
    setLoading
  });
  const [generalQuestions, setGeneralQuestions] = useState(elster.general_question);
  const [wageCosts, setWageCosts] = useState(elster.wage_cost);
  const [affiliates, setAffiliates] = useState(elster.affiliate);
  const [furtherInformations, setFurtherInformations] = useState(elster.further_information);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [projectDetails, setProjectDetails] = useState({});
  const [selectedProject, setSelectedProject] = elsterProjectsService.useGet(elster.id, selectedProjectId);
  const history = useHistory();
  const {
    search
  } = useLocation();
  const {
    t
  } = useTranslation();
  const financialYear = elster.start_date.slice(-4);
  const goToTab = key => {
    setKey(key);
    const subTabKey = key === 'project_details' ? 'employee' : 'none';
    history.push({
      search: `?main_tab=${key}&sub_tab1=${subTabKey}&p_id=${selectedProjectId || ''}`
    });
  };
  useEffect(() => {
    const main_tab = new URLSearchParams(search).get('main_tab');
    const pId = new URLSearchParams(search).get('p_id');
    if (!pId) return;
    setSelectedProjectId(pId);
    if (!main_tab) {
      history.push({
        search: `?main_tab=${key}`
      });
    } else {
      setKey(main_tab);
    }
  }, [history, key, search]);
  if (loading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Header, null, "Company Costs - ", financialYear), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Tabs, {
    onSelect: goToTab,
    className: "mb-3",
    activeKey: key,
    defaultActiveKey: 'project_overview'
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_overview",
    title: t('project_overview')
  }, /*#__PURE__*/React.createElement(ProjectOverview, {
    claimProjectReports: projectReports,
    financialYear: financialYear,
    elster: elster,
    setElster: setElster,
    fetchAllProjetcs: fetchAllProjetcs,
    fetchElster: fetchElster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "general_company_information",
    title: t('general_company_information')
  }, /*#__PURE__*/React.createElement(GeneralCompanyInformation, {
    generalQuestions: generalQuestions,
    setGeneralQuestions: setGeneralQuestions,
    wageCosts: wageCosts,
    setWageCosts: setWageCosts,
    financialYear: financialYear,
    affiliates: affiliates,
    setAffiliates: setAffiliates,
    furtherInformations: furtherInformations,
    setFurtherInformations: setFurtherInformations,
    elsterId: elster.id
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_details",
    title: t('project_details')
  }, /*#__PURE__*/React.createElement(ProjectDetailTabs, {
    setSelectedProject: setSelectedProject,
    selectedProject: selectedProject,
    setProjectReports: setProjectReports,
    projectReports: projectReports,
    handleToaster: handleToaster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "summary",
    title: t('summary')
  }, "Under development. please comeback later."))));
};
export default CompanyCosts;